export const POWERBI_NAME = "powerbi";
export const POWERBI_DISPLAY_NAME = "Power BI";

export const BASE_URL_PREFIX = `/config/${POWERBI_NAME}`;
